import { gql } from '@apollo/client'

export const POWER_BI_TOKEN_CREATE_MUTATION = gql`
  mutation POWER_BI_TOKEN_CREATE_MUTATION($input: PowerBITokenCreateInput!) {
    powerBITokenCreate(input: $input) {
      data {
        token
        expiration
      }
    }
  }
`

export const POWER_BI_REFRESH_DATASET_MUTATION = gql`
  mutation POWER_BI_REFRESH_DATASET_MUTATION {
    powerBIRefreshDatasets {
      ok
    }
  }
`

export const POWER_BI_CREATE_REPORT_MUTATION = gql`
  mutation POWER_BI_CREATE_REPORT_MUTATION($input: PowerBIReportCreateInput!) {
    powerBIReportCreate(input: $input) {
      data {
        token
      }
    }
  }
`

export const POWER_BI_CREATE_REPORT_CALLBACK_MUTATION = gql`
  mutation POWER_BI_CREATE_REPORT_CALLBACK_MUTATION($input: PowerBIReportCreateCallbackInput!) {
    powerBIReportCreateCallback(input: $input) {
      ok
    }
  }
`

export const POWER_BI_CLONE_REPORT_MUTATION = gql`
  mutation POWER_BI_CLONE_REPORT_MUTATION($input: PowerBIReportCloneInput!) {
    powerBIReportClone(input: $input) {
      data {
        id
      }
    }
  }
`

export const POWER_BI_DELETE_REPORT_MUTATION = gql`
  mutation POWER_BI_DELETE_REPORT_MUTATION($id: ID!) {
    powerBIReportDelete(id: $id) {
      data {
        token
      }
    }
  }
`

export const POWER_BI_START_EXPORT_MUTATION = gql`
  mutation POWER_BI_START_EXPORT_MUTATION($input: PowerBIStartExportToFileInput!) {
    powerBIStartExportToFile(input: $input) {
      data {
        exportId
      }
    }
  }
`

export const POWER_BI_UPDATE_REPORT_MUTATION = gql`
  mutation POWER_BI_UPDATE_REPORT_MUTATION($id: ID!, $input: PowerBIReportUpdateInput!) {
    powerBIReportUpdate(id: $id, input: $input) {
      data {
        id
        name
        customName
      }
    }
  }
`

export const POWER_BI_UPDATE_STANDARD_REPORT_MUTATION = gql`
  mutation POWER_BI_UPDATE_STANDARD_REPORT_MUTATION($input: PowerBIUpdateStandardReportInput!) {
    powerBIUpdateStandardReport(input: $input) {
      ok
    }
  }
`
